var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 165,
    viewBox: "0 0 135 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.669 72.7875H16.7226L16.7749 45.8712C17.4075 33.1758 23.209 21.7966 32.2013 13.5589L32.2719 13.492C41.4329 5.1382 53.8741 0 67.4978 0C81.147 0 93.6219 5.15561 102.796 13.5596C111.955 21.9545 117.809 33.6115 118.255 46.5945L118.28 72.7866H121.329C125.095 72.7866 128.533 74.2505 130.993 76.5845L131.654 77.2881C133.734 79.5726 135 82.5302 135 85.7457V152.04C135 155.611 133.456 158.87 130.994 161.202C128.534 163.536 125.097 165 121.33 165H13.6701C9.90383 165 6.46616 163.536 4.00604 161.202C1.54414 158.87 0 155.611 0 152.04V85.7457C0 82.2056 1.53723 78.9722 4.00604 76.6142C6.46616 74.2497 9.90318 72.7858 13.6701 72.7858L13.669 72.7875ZM67.4997 96.309C72.5521 96.309 76.6476 100.192 76.6476 104.982C76.6476 108.769 74.0893 111.984 70.5219 113.169L72.073 119.916L76.6483 139.8H58.3528L62.928 119.916L64.4791 113.169C60.9111 111.984 58.3535 108.769 58.3535 104.982C58.3535 100.192 62.449 96.309 67.5013 96.309H67.4997ZM33.1199 72.7875H101.88V46.8398C101.537 38.1482 97.5833 30.3537 91.4527 24.7315C85.2516 19.0346 76.8031 15.5571 67.4993 15.5571C58.2034 15.5571 49.7582 19.0303 43.5893 24.6885C37.4933 30.2858 33.5577 37.9598 33.1126 46.5219L33.1199 72.7875Z",
    fill: "#00739A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.45a48074c435a33b7301db0f1e52a92f.svg";
export { ForwardRef as ReactComponent };